import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { api, num } from "@/lib/api";
import { PageHeader, Card, Table, Money } from "@/components/common";
import { VarianceTable } from "@/pages/Variance";

const TABS = [["pnl", "Laba rugi outlet"], ["sales", "Penjualan"], ["cogs", "COGS / konsumsi"], ["inventory", "Inventaris"], ["variance", "Variansi"]];
const monthStart = () => { const d = new Date(Date.now() + 7 * 3600e3); return `${d.toISOString().slice(0, 8)}01`; };
const toUtc = (d) => (d ? new Date(`${d}T00:00:00+07:00`).toISOString() : undefined);

const Pnl = ({ p }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/reports/pnl", { params: p }).then((r) => setD(r.data)); }, [p]);
  if (!d) return null;
  const rows = [...d.rows, { ...d.total, name: "TOTAL", location_id: "total" }];
  const M = (k, bold) => ({ h: k[1], right: true, r: (r) => <Money v={r[k[0]]} className={bold || r.location_id === "total" ? "font-bold" : ""} /> });
  return <Table testid="pnl-table" rows={rows} cols={[{ h: "Lokasi", r: (r) => <b>{r.name}</b> }, M(["revenue", "Pendapatan"]), M(["cogs", "COGS"]), M(["gross_profit", "Laba kotor"], true),
    M(["opex", "Biaya operasional"]), M(["waste", "Waste/penyesuaian"]), M(["variance", "Variansi opname"]), M(["ebitda", "EBITDA operasional"], true),
    M(["central_purchases", "Pembelian pusat"]), M(["direct_purchases", "Pembelian langsung"]), M(["transfers_in", "Transfer diterima"]), M(["transfers_out", "Transfer dikirim"]), M(["inventory_value", "Nilai stok"])]} />;
};

const Consumption = ({ p, mode }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/reports/consumption", { params: p }).then((r) => setD(r.data)); }, [p]);
  if (!d) return null;
  return mode === "sales"
    ? <Table testid="sales-report-table" rows={d.products} cols={[{ h: "Outlet", k: "location_name" }, { h: "Produk", k: "product" }, { h: "Qty", right: true, r: (r) => <span className="num">{num(r.qty)}</span> }, { h: "Penjualan", right: true, r: (r) => <Money v={r.amount} className="font-semibold" /> }]} />
    : <Table testid="cogs-report-table" rows={d.consumption} cols={[{ h: "Outlet", k: "location_name" }, { h: "Barang", k: "item_name" }, { h: "Konsumsi teoritis", right: true, r: (r) => <span className="num">{num(r.qty)} {r.unit}</span> }, { h: "COGS", right: true, r: (r) => <Money v={r.value} className="font-semibold" /> }]} />;
};

const Inventory = () => {
  const [d, setD] = useState([]);
  useEffect(() => { api.get("/reports/inventory").then((r) => setD(r.data)); }, []);
  return <div className="divide-y">{d.map((l) => (
    <details key={l.location.id} className="group" open={l.location.type === "warehouse"}>
      <summary className="px-4 py-3 flex justify-between cursor-pointer font-semibold text-sm"><span>{l.location.name}</span><Money v={l.value} /></summary>
      <Table rows={l.rows} cols={[{ h: "Barang", k: "item_name" }, { h: "Kategori", k: "category" }, { h: "Qty", right: true, r: (r) => <span className="num">{num(r.qty)} {r.unit}</span> }, { h: "Nilai", right: true, r: (r) => <Money v={r.value} /> }]} />
    </details>))}</div>;
};

export default function Reports() {
  const { tab } = useParams();
  const [range, setRange] = useState({ start: monthStart(), end: "" });
  const p = { start: toUtc(range.start), end: range.end ? new Date(new Date(`${range.end}T00:00:00+07:00`).getTime() + 864e5).toISOString() : undefined };
  const key = JSON.stringify(p);
  return (
    <div>
      <PageHeader title="Laporan" sub="Pendapatan dari impor POS, COGS dari konsumsi teoritis resep, nilai stok dari ledger.">
        {["pnl", "sales", "cogs"].includes(tab) && <div className="flex items-center gap-2 text-sm">
          <input type="date" className="inp !w-40" value={range.start} onChange={(e) => setRange({ ...range, start: e.target.value })} data-testid="report-start-input" /> s/d
          <input type="date" className="inp !w-40" value={range.end} onChange={(e) => setRange({ ...range, end: e.target.value })} data-testid="report-end-input" /></div>}
      </PageHeader>
      <div className="flex gap-1 mb-3 border-b overflow-x-auto">
        {TABS.map(([k, l]) => <NavLink key={k} to={`/reports/${k}`} data-testid={`report-tab-${k}`} className={({ isActive }) => `px-3 py-2 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap ${isActive ? "border-emerald-600 text-emerald-700" : "border-transparent text-slate-500"}`}>{l}</NavLink>)}
      </div>
      <Card key={key + tab}>
        {tab === "pnl" && <Pnl p={p} />}
        {tab === "sales" && <Consumption p={p} mode="sales" />}
        {tab === "cogs" && <Consumption p={p} mode="cogs" />}
        {tab === "inventory" && <Inventory />}
        {tab === "variance" && <VarianceTable />}
      </Card>
    </div>
  );
}
